import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faCheck, faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import "./complain.scss";
import { formatDateTime } from "utils/dateFormat";

/**
 * One complaint, as an inbox row.
 *
 * IT WAS A CARD GRID, and that was the wrong shape for the content. A complaint
 * is usually one short line — «صوصات», «بدون تأخير» — so each card was a few
 * words floating in a box of padding, and six of them filled a screen while
 * saying almost nothing. Rows put the same information in a third of the height
 * and let an operator read down a column of them.
 *
 * READ VS UNREAD: an unread row is on the RAISED surface with a brand edge and
 * a «جديدة» chip and offers the read action; a read one is RECESSED with none
 * of them. Surface and a chip rather than dimmed text — the light theme's body
 * colour is 5.18:1 on white and cannot be faded without failing AA.
 *
 * ONE PRIMARY ACTION. Replying is what an operator opens this screen to do, so
 * it is the only filled control; marking read and deleting are icon buttons
 * that appear beside it.
 */
const Complain = (props) => {
    const complain = props.complain;
    const date = complain?.createdAt ? new Date(complain.createdAt) : null;
    const isUnread = complain?.seen === false;

    return (
        <div
            className={`complain ${
                isUnread ? "surface-card complain--unread" : "surface-inset complain--read"
            }`}
        >
            <div className="complain__main">
                <div className="complain__line">
                    {isUnread ? <span className="complain__new">جديدة</span> : null}
                    <h4 className="complain__title">{complain?.title}</h4>
                    <span className="complain__from">
                        {complain?.name || "—"} · {complain?.phone || "—"}
                    </span>
                </div>
                <p className="complain__body">{complain?.description}</p>
            </div>

            <div className="complain__side">
                {date ? (
                    <span className="complain__time">
                        <bdi dir="ltr">{formatDateTime(date)}</bdi>
                    </span>
                ) : null}
                <div className="complain__actions">
                    {isUnread ? (
                        <button
                            className="complain__icon complain__icon--seen"
                            title="تمّت القراءة"
                            aria-label="تمّت القراءة"
                            onClick={() => props.onMarkSeen?.(complain)}
                        >
                            <FontAwesomeIcon icon={faCheck} />
                        </button>
                    ) : null}
                    <button
                        className="complain__icon complain__icon--delete"
                        title="حذف الشكوى"
                        aria-label="حذف الشكوى"
                        onClick={() => {
                            props.toggleDelete();
                            props.setSelectedComplainValue(complain);
                        }}
                    >
                        <FontAwesomeIcon icon={faTrash} />
                    </button>
                    <button
                        className="complain__reply"
                        onClick={() => {
                            props.toggleNotification();
                            props.setSelectedComplainValue(complain);
                        }}
                    >
                        <FontAwesomeIcon icon={faPaperPlane} size="sm" /> رد
                    </button>
                </div>
            </div>
        </div>
    );
};
export default Complain;
